export function parseApiError(error: any): string {
  if (!error) return "Unknown error"

  if (error.detail) return error.detail

  if (error.errors) {
    return Object.values(error.errors).flat().join(", ")
  }

  return "Request failed"
}